// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KeyValueListTable {
  border-collapse: collapse;
  margin: 0px 0;
  font-family: Roboto;
  font-weight: 300;
}

.KeyValueListTable tr,
.KeyValueListTable td {
  padding: 5px 15px;
}
`, "",{"version":3,"sources":["webpack://./src/app/common/KeyValList/KeyValueList.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB","sourcesContent":[".KeyValueListTable {\n  border-collapse: collapse;\n  margin: 0px 0;\n  font-family: Roboto;\n  font-weight: 300;\n}\n\n.KeyValueListTable tr,\n.KeyValueListTable td {\n  padding: 5px 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
